import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import i18n from 'util/i18n';

import { getSectionNumber } from 'helpers/navigation';
import Field from 'components/Form/Field';
import { isPVQForm } from 'helpers/form';

const SectionIntro = function ({
  title, body, sectionNumber, fieldTitle, formType, isSimpleTitle, bullets
}) {
  const isPvq = isPVQForm(formType);
  let introTitle = isPvq ? `${i18n.t('section.pvqSection')} ${sectionNumber}: ${title}` : `${i18n.t('section.section')} ${sectionNumber}: ${title}`;
  if (isSimpleTitle) {
    introTitle = `${title}`;
  }

  return (
    <div>
      <h1 className="section-header">{introTitle}</h1>

      <Field title={fieldTitle} optional className="no-margin-bottom">
        {body}
        {bullets?.length > 0 && (
          <ul>
            {bullets?.map((bullet: string) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
        )}
      </Field>
    </div>
  );
};

SectionIntro.propTypes = {
  title: PropTypes.node.isRequired,
  bullets: PropTypes.arrayOf(PropTypes.string),
  body: PropTypes.node.isRequired,
  sectionNumber: PropTypes.number.isRequired,
  fieldTitle: PropTypes.node,
  formType: PropTypes.string,
  isSimpleTitle: PropTypes.bool,
};

SectionIntro.defaultProps = {
  bullets: undefined,
  fieldTitle: undefined,
  formType: '',
  isSimpleTitle: false,
};

const mapStateToProps = (state, ownProps) => ({
  formType: state.application.Settings?.formType,
  sectionNumber: getSectionNumber(state, ownProps),
});

export default connect(mapStateToProps)(SectionIntro);
